import { UrlPrefixEnum, UrlTargetEnum } from '../../../types/cmsEnums';
import { VerticalType } from '../../../types/cmsTypes';
import { BrandId } from '../../../utils/override';
import { getCmsPageLink } from '../../../utils/routing';
import { NavigationItemTypeEnum } from '../types';

export const navbarLinkToUrl = (
  link: {
    label?: string;
    type?: NavigationItemTypeEnum;
    url?: string | null;
    url_target?: UrlTargetEnum;
    page?: {
      slug: string;
      section?: VerticalType | null;
      urlPrefix?: UrlPrefixEnum;
    } | null;
    article?: {
      slug: string;
      section?: VerticalType | null;
      urlPrefix?: UrlPrefixEnum;
    } | null;
  },
  options: {
    brand: BrandId;
    langPrefix: string;
  },
): { href: string; text: string; url_target?: string } => {
  let href = '';
  const url_target = link.url_target
    ? `_${link.url_target}`.toLowerCase()
    : undefined;
  const text = link.label ?? '';

  switch (link.type) {
    case 'page': {
      if (link.page) {
        href = getCmsPageLink({
          brand: options.brand,
          pageType: 'page',
          vertical: link.page!.section!,
          slug: link.page!.slug as string,
          langPrefix: options.langPrefix,
          urlPrefix: link.page.urlPrefix,
        });
      }
      break;
    }
    case 'article': {
      if (link.article) {
        href = getCmsPageLink({
          brand: options.brand,
          pageType: 'article',
          vertical: link.article!.section!,
          slug: link.article!.slug as string,
          langPrefix: options.langPrefix,
          urlPrefix: link.article.urlPrefix,
        });
      }
      break;
    }
    default: {
      href = link.url ?? '#';
      break;
    }
  }

  return {
    href,
    text,
    url_target,
  };
};
